const $ = jQuery

function getTimeRemaining (endtime) {
  const total = Date.parse(endtime) - Date.parse(new Date())
  const seconds = Math.floor((total / 1000) % 60)
  const minutes = Math.floor((total / 1000 / 60) % 60)
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
  const days = Math.floor(total / (1000 * 60 * 60 * 24))

  return {
    total,
    days,
    hours,
    minutes,
    seconds
  }
}

function initializeClock (clockEl, endtime, onDone = () => {}) {
  const clock = clockEl
  const daysSpan = clock.querySelector('.days')
  const hoursSpan = clock.querySelector('.hours')
  const minutesSpan = clock.querySelector('.minutes')
  const secondsSpan = clock.querySelector('.seconds')

  function updateClock () {
    const t = getTimeRemaining(endtime)

    if (t.days >= 0) {
      let days = ('0' + t.days).slice(-2).split('')
      daysSpan.innerHTML = `
        <div class="mtt-products__clock-group-item">${ days[0] }</div>
        <div class="mtt-products__clock-group-item">${ days[1] }</div>
      `
    }
    if (t.hours >= 0) {
      let hours = ('0' + t.hours).slice(-2).split('')
      hoursSpan.innerHTML = `
        <div class="mtt-products__clock-group-item">${ hours[0] }</div>
        <div class="mtt-products__clock-group-item">${ hours[1] }</div>
      `
    }
    if (t.minutes >= 0) {
      let minutes = ('0' + t.minutes).slice(-2).split('')
      minutesSpan.innerHTML = `
        <div class="mtt-products__clock-group-item">${ minutes[0] }</div>
        <div class="mtt-products__clock-group-item">${ minutes[1] }</div>
      `
    }
    if (t.seconds >= 0) {
      let seconds = ('0' + t.seconds).slice(-2).split('')
      secondsSpan.innerHTML = `
        <div class="mtt-products__clock-group-item">${ seconds[0] }</div>
        <div class="mtt-products__clock-group-item">${ seconds[1] }</div>
      `
    }

    if (t.total <= 0) {
      clearInterval(timeinterval)
      onDone()
    }
  }

  updateClock()
  const timeinterval = setInterval(updateClock, 1000)
}

module.exports = {
  initializeClock
}
